import { render, staticRenderFns } from "./DecoderConfiguration.vue?vue&type=template&id=3dbd4fee&"
import script from "./DecoderConfiguration.vue?vue&type=script&lang=ts&"
export * from "./DecoderConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports